import React from 'react';
import { isSameValue } from '../../utils/common';

const PlayersTemplateTableCell = (props) => {
  if (isSameValue(props.oldValue, props.newValue, props.type)) {
    return props.newValue;
  }
  return (
    <div className="d-flex align-items-center flex-direction-vertical justify-content-center">
      <div className="txt-striked">{props.oldValue}</div>
      <div className="mx-2 arrow-right" />
      <div>{props.newValue}</div>
    </div>
  );
};
export default PlayersTemplateTableCell;
